import type { FaireProductEntity } from "../../entity_types/product";

export const p_zsqxd6vgnt: FaireProductEntity = {
  token: "p_zsqxd6vgnt",
  type: "product",
  name: "Natural Multi Color Gemstone Handmade Chain Bracelets For Women Wholesale Lot Assorted Crystal Silver Plated Bracelets",
  brandToken: "b_gvkc6qnpt8",
  brandName: "Handmade Jewels",
  imageUrl: "https://cdn.faire.com/fastly/f7792026223153ac7d476eea3e0aff545a4570308b500806ae8a1680494dd47f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67beaf93ae352fcd96302e3bb9161715d9fe23b52acffa7ed560af16cb5fbbb3.jpeg",
    "https://cdn.faire.com/fastly/8aa867a14a47ad07b548839153ad616b7f86c9b5dfceb5178864afb5fd7c2c0a.jpeg",
    "https://cdn.faire.com/fastly/ab5245f45096d9250ec0829313288143bf9d233f0aff81dbd060bfdddba74bb9.jpeg",
    "https://cdn.faire.com/fastly/17335457695aa0a28b62ad06628e5635779c770bf13fd3f66a754dd8fa7dda8d.jpeg",
    "https://cdn.faire.com/fastly/5f8c758bd8f20d1e332290d26240d49e264ca374b71be4f3c8cc4593d3f8baf5.jpeg"
  ],
  priceDollars: 81.74,
  description: "\n * Unique Bracelet Assorted Crystal Handmade Chain Bracelets For Women Wholesale Lot Multi Color Silver Plated Bracelets \n * Metal :- Brass Silver Plated \n * Gemstone :- Assorted \n * Size :- 7.5 to 8 Inches ",
  tags: [],
  msrpDollars: 163.48,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:56.109Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
